<template>
  <li class="anchor-card">
    <LangRouterLink
      :to="{ name: $route.name ?? 'about', hash: `#${content.section}` }"
      :title="content.title"
    >
      <Image :source="content.icon" class="anchor-card__icon" />
      <p class="anchor-card__title subtitle">
        <span>{{ content.title }}</span>
        <Icon id="arrow" />
      </p>
      <p>{{ content.description }}</p>
    </LangRouterLink>
  </li>
</template>

<script>
import { Icon, Image, LangRouterLink } from '@/components/global'
import { DefaultSectionProps } from '@/mixins'

export default {
  name: 'AnchorCard',
  mixins: [DefaultSectionProps],
  components: { Icon, Image, LangRouterLink },
}
</script>
